"use strict";
/* globals module */
/**
 * @module userProfileAvatarRoute
 * @description Baasic User Profile Avatar Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic User Profile Avatar Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../../common");
;
var _1 = require("./");
var contracts_1 = require("../../../core/contracts");
var UserProfileAvatarRoute = /** @class */ (function (_super) {
    tslib_1.__extends(UserProfileAvatarRoute, _super);
    function UserProfileAvatarRoute(appOptions, userProfileAvatarStreamsRoute) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.userProfileAvatarStreamsRoute = userProfileAvatarStreamsRoute;
        _this.getRoute = 'profiles/{id}/avatars/{?embed,fields}';
        _this.updateRoute = 'profiles/{id}/avatars';
        _this.linkRoute = 'profiles/{id}/avatars/link';
        _this.unlinkRoute = 'profiles/{id}/avatars/unlink';
        return _this;
    }
    Object.defineProperty(UserProfileAvatarRoute.prototype, "streams", {
        get: function () {
            return this.userProfileAvatarStreamsRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses get route; this route should be expanded with the Id of the profile.
     * @method
     * @param id User Profile id which uniquely identifies user avatar resource that needs to be retrieved.
     * @param options Query resource options object.
     * @example userProfileAvatarRoute.get({id: '<file-id>'});
     **/
    UserProfileAvatarRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses update route; this URI template does not expose any additional options.
     * @method
     * @param data A Profile Avatar object used to update specified Profile Avatar resource.
     * @example userProfileAvatarRoute.update(data);
     **/
    UserProfileAvatarRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses link route; this route should be expanded with the Id of the profile.
     * @method
     * @param id User Profile id which uniquely identifies user avatar resource that needs to be retrieved.
     * @param data A Profile Avatar object used to link specified Profile Avatar resource.
     * @example userProfileAvatarRoute.link({id: '<file-id>'});
     **/
    UserProfileAvatarRoute.prototype.link = function (id, data) {
        var params = this.utility.extend({}, data);
        params.id = id;
        return _super.prototype.baseCreate.call(this, this.linkRoute, params);
    };
    /**
     * Parses link route; this route should be expanded with the Id of the profile.
     * @method
     * @param data A Profile Avatar object used to unlink specified Profile Avatar resource.
     * @param options Query resource options object.
     * @example userProfileAvatarRoute.unlink(data);
     **/
    UserProfileAvatarRoute.prototype.unlink = function (data, options) {
        if (!options) {
            options = {};
        }
        return _super.prototype.baseDelete.call(this, this.unlinkRoute, data, options);
    };
    UserProfileAvatarRoute.prototype.createParams = function (data, id) {
        var params = this.utility.extend(data);
        params.id = id;
        return _super.prototype.createParams.call(this, params);
    };
    var _a, _b;
    UserProfileAvatarRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.UserProfileAvatarStreamsRoute)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object, typeof (_b = typeof _1.UserProfileAvatarStreamsRoute !== "undefined" && _1.UserProfileAvatarStreamsRoute) === "function" ? _b : Object])
    ], UserProfileAvatarRoute);
    return UserProfileAvatarRoute;
}(common_1.BaseRoute));
exports.UserProfileAvatarRoute = UserProfileAvatarRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 
